import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Support } from '@shared/models/global.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  apiUrl = environment.api.root;
  private readonly http: HttpClient = inject(HttpClient);

  constructor() {}

  getSupport(): Observable<Support> {
    return this.http.get<Support>(`${this.apiUrl}/Global/Support`);
  }
}
